import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionReportComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { FillInBlankDescription } from './components';
import styled from '@xstyled/styled-components';
import { getSize, getColor } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// ─── Styled Components ────────────────────────────────────────────────────────
var StyledPanel = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  margin-top: ", ";\n"])), getSize('padding12'), getSize('padding16'));
var StyledSummaryBar = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), getColor('fillIntSubActive'), getSize('radiusSm'));
var StyledSummaryCell = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding: ", ";\n"])), getSize('gap4'), getSize('padding16'));
var StyledSummaryCellDivider = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 1px;\n  background: ", ";\n  flex-shrink: 0;\n"])), getColor('fillIntSubActive'));
var StyledSummaryCellLabel = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1rem;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledSummaryCellValue = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.2;\n"])), getSize('typo24'), function (_ref) {
  var $isError = _ref.$isError;
  return $isError ? getColor('errorActive') : getColor('contentTitle');
});
var StyledSummaryCellDesc = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.4;\n  margin-top: 2px;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledDetailSection = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('gap8'));
var StyledDetailHeader = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledBlankList = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('gap8'));
var StyledBlankRow = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  border: 1px solid\n    ", ";\n"])), getSize('padding16'), getSize('padding16'), getSize('radiusSm'), function (_ref2) {
  var $status = _ref2.$status;
  return $status === 'danger' ? getColor('errorBgActive') : $status === 'success' ? getColor('successBgActive') : getColor('fillBgSub');
}, function (_ref3) {
  var $status = _ref3.$status;
  return $status === 'danger' ? getColor('errorHighlighted') : $status === 'success' ? getColor('successHighlighted') : getColor('fillIntSubActive');
});
var StyledBlankBadge = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 48px;\n  height: 48px;\n  border-radius: ", ";\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  letter-spacing: 0.02em;\n"])), getSize('radiusSm'), function (_ref4) {
  var $status = _ref4.$status;
  return $status === 'danger' ? getColor('errorActive') : $status === 'success' ? getColor('successActive') : getColor('contentBody');
}, getColor('textIntWhite'), getSize('typo16'));
var StyledBlankCols = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  flex: 1;\n  gap: ", ";\n"])), getSize('gap32'));
var StyledBlankCol = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 120px;\n"])));
var StyledBlankColHeader = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledBlankColValue = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo14'), function (_ref5) {
  var $variant = _ref5.$variant;
  return $variant === 'error' ? getColor('errorActive') : $variant === 'success' ? getColor('successActive') : getColor('contentTitle');
});
var StyledBlankWarningBadge = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 6px 14px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  white-space: nowrap;\n  flex-shrink: 0;\n"])), getSize('gap4'), getColor('errorBgActive'), getColor('errorHighlighted'), getSize('radiusRounded'), getSize('typo12'), getColor('errorActive'));
var StyledBlankSuccessBadge = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  padding: 6px 14px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  white-space: nowrap;\n  flex-shrink: 0;\n"])), getSize('gap4'), getColor('successBgActive'), getColor('successHighlighted'), getSize('radiusRounded'), getSize('typo12'), getColor('successActive')); // ─── Stats Panel Component ────────────────────────────────────────────────────

var getBlankStatus = function getBlankStatus(pct) {
  if (pct < 50) return 'danger';
  if (pct > 80) return 'success';
  return 'normal';
};

var FillInBlankStatsPanel = function FillInBlankStatsPanel(_ref6) {
  var _question$index;

  var totalCandidates = _ref6.totalCandidates,
      totalBlanks = _ref6.totalBlanks,
      accuracy = _ref6.accuracy,
      answerReports = _ref6.answerReports,
      labels = _ref6.labels;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var startIndex = (_question$index = question === null || question === void 0 ? void 0 : question.index) !== null && _question$index !== void 0 ? _question$index : 1;
  var blanks = answerReports === null || answerReports === void 0 ? void 0 : answerReports.map(function (answerReport, i) {
    var _answerReport$totalCo, _answerReport$totalCo2, _answerReport$totalWr, _answerReport$correct;

    return {
      index: startIndex + i,
      correctCount: (_answerReport$totalCo = answerReport === null || answerReport === void 0 ? void 0 : answerReport.totalCorrectAnswers) !== null && _answerReport$totalCo !== void 0 ? _answerReport$totalCo : 0,
      totalCount: ((_answerReport$totalCo2 = answerReport === null || answerReport === void 0 ? void 0 : answerReport.totalCorrectAnswers) !== null && _answerReport$totalCo2 !== void 0 ? _answerReport$totalCo2 : 0) + ((_answerReport$totalWr = answerReport === null || answerReport === void 0 ? void 0 : answerReport.totalWrongAnswers) !== null && _answerReport$totalWr !== void 0 ? _answerReport$totalWr : 0),
      correctPercentage: (_answerReport$correct = answerReport === null || answerReport === void 0 ? void 0 : answerReport.correctAnswerPercentage) !== null && _answerReport$correct !== void 0 ? _answerReport$correct : 0
    };
  });
  return /*#__PURE__*/_jsxs(StyledPanel, {
    children: [/*#__PURE__*/_jsxs(StyledSummaryBar, {
      children: [/*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.totalCandidates
        }), /*#__PURE__*/_jsx(StyledSummaryCellValue, {
          children: totalCandidates
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.studentsAttemptedDesc
        })]
      }), /*#__PURE__*/_jsx(StyledSummaryCellDivider, {}), /*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.overallAccuracy
        }), /*#__PURE__*/_jsxs(StyledSummaryCellValue, {
          $isError: accuracy === 0,
          children: [accuracy, "%"]
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.studentsAllBlanksCorrectDesc
        })]
      }), /*#__PURE__*/_jsx(StyledSummaryCellDivider, {}), /*#__PURE__*/_jsxs(StyledSummaryCell, {
        children: [/*#__PURE__*/_jsx(StyledSummaryCellLabel, {
          children: labels.totalBlanks
        }), /*#__PURE__*/_jsx(StyledSummaryCellValue, {
          children: totalBlanks
        }), /*#__PURE__*/_jsx(StyledSummaryCellDesc, {
          children: labels.fillInBlankSlotsDesc
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledDetailSection, {
      children: [/*#__PURE__*/_jsx(StyledDetailHeader, {
        children: labels.detailPerBlank
      }), /*#__PURE__*/_jsx(StyledBlankList, {
        children: blanks === null || blanks === void 0 ? void 0 : blanks.map(function (blank) {
          var status = getBlankStatus(blank.correctPercentage);
          var badgeNum = String(blank.index).padStart(2, '0');
          var wrongPct = 100 - blank.correctPercentage;
          return /*#__PURE__*/_jsxs(StyledBlankRow, {
            $status: status,
            children: [/*#__PURE__*/_jsx(StyledBlankBadge, {
              $status: status,
              children: badgeNum
            }), /*#__PURE__*/_jsxs(StyledBlankCols, {
              children: [/*#__PURE__*/_jsxs(StyledBlankCol, {
                children: [/*#__PURE__*/_jsx(StyledBlankColHeader, {
                  children: labels.correctCount
                }), /*#__PURE__*/_jsxs(StyledBlankColValue, {
                  $variant: blank.correctCount === 0 ? 'error' : 'success',
                  children: [blank.correctCount, " / ", blank.totalCount, " ", labels.candidatesSuffix]
                })]
              }), /*#__PURE__*/_jsxs(StyledBlankCol, {
                children: [/*#__PURE__*/_jsx(StyledBlankColHeader, {
                  children: labels.accuracyPercent
                }), /*#__PURE__*/_jsxs(StyledBlankColValue, {
                  $variant: status === 'danger' ? 'error' : status === 'success' ? 'success' : 'default',
                  children: [blank.correctPercentage, "%"]
                })]
              })]
            }), status === 'danger' && /*#__PURE__*/_jsx(StyledBlankWarningBadge, {
              children: labels.warningBadge(wrongPct)
            }), status === 'success' && /*#__PURE__*/_jsx(StyledBlankSuccessBadge, {
              children: labels.successBadge(blank.correctPercentage)
            })]
          }, blank.index);
        })
      })]
    })]
  });
};

export var FillInBlankReportComponent = function FillInBlankReportComponent(_ref7) {
  var states = _ref7.states,
      actions = _ref7.actions;

  var _useQuestionContext2 = useQuestionContext(),
      question = _useQuestionContext2.question;

  var totalCandidates = states.totalCandidates,
      totalBlanks = states.totalBlanks,
      accuracy = states.accuracy,
      answerReports = states.answerReports,
      fillInBlankReportLabel = states.fillInBlankReportLabel;

  var customDescription = /*#__PURE__*/_jsx(FillInBlankDescription, {
    description: question.description,
    answers: question.answers,
    startQuestionIndex: question.index
  });

  return /*#__PURE__*/_jsx(BaseQuestionReportComponent, {
    states: _objectSpread(_objectSpread({}, states), {}, {
      customDescription: customDescription
    }),
    actions: actions,
    children: /*#__PURE__*/_jsx(FillInBlankStatsPanel, {
      totalCandidates: totalCandidates,
      totalBlanks: totalBlanks,
      accuracy: accuracy,
      answerReports: answerReports,
      labels: fillInBlankReportLabel
    })
  });
};